"use client";

import * as React from "react";
import { usePathname } from "next/navigation";
import { ThemeProvider as NextThemesProvider } from "next-themes";
import { forcedThemeOf } from "@/utils/forcedTheme.utils";
export function ThemeProvider({
  children,
  ...props
}: React.ComponentProps<typeof NextThemesProvider>) {
  const pathname = usePathname();
  return <NextThemesProvider {...props} forcedTheme={forcedThemeOf(pathname)} data-sentry-element="NextThemesProvider" data-sentry-component="ThemeProvider" data-sentry-source-file="theme-provider.tsx">
            {children}
        </NextThemesProvider>;
}